import { render, staticRenderFns } from "./componentMenuColumn.vue?vue&type=template&id=3479598e&scoped=true"
import script from "./componentMenuColumn.vue?vue&type=script&lang=js"
export * from "./componentMenuColumn.vue?vue&type=script&lang=js"
import style0 from "./componentMenuColumn.vue?vue&type=style&index=0&id=3479598e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3479598e",
  null
  
)

export default component.exports